import { Article } from "@/services/Articles/updateArticle";
import dayjs from "dayjs";
import { FC } from "react";
import { Tooltip } from "antd";
import { t } from "i18next";

export const BlogGridItem: FC<Article> = ({ title, category, updatedDate, imgUrl, isPublic, isPinned }) => {
    const formattedDate = dayjs(updatedDate).format("D MMMM YYYY");
    let isPublicColor;
    if (isPublic === true) {
        isPublicColor = "green"
    } else if (isPublic === false) {
        isPublicColor = "red"
    } else {
        isPublicColor = "var(--color-text)";
    }
    return (
        <div className="blog-item" style={{ color: 'var(--color-text)', overflow: "visible", }}>
            <div
                style={{
                    position: 'relative',       // mutlak pozisyon için parent relative olmalı
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'end',
                }}
            >
                {isPinned && (
                    <Tooltip title={t("pinnedText")}>
                        <span
                            style={{
                                position: 'absolute',
                                top: '-15px',
                                fontSize: '20px',
                                zIndex: 10,
                            }}
                        >
                            📌
                        </span>
                    </Tooltip>

                )}
                <img
                    src={imgUrl}
                    alt={title}
                    style={{
                        width: "100%",
                        aspectRatio: '2 / 1',
                        objectFit: "cover",
                        borderRadius: "5px"
                    }}
                />
            </div>

            <div>
                <span
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "10px",
                    }}
                >
                    <p style={{ color: "#3f51b5" }}>{category}</p>
                    <div
                        style={{
                            width: "5px",
                            height: "5px",
                            backgroundColor: "black",
                            borderRadius: "100px",
                        }}
                    ></div>
                    <p
                        style={{
                            color: isPublicColor
                        }}
                    >
                        {formattedDate}</p>
                </span>

                <h2 style={{ fontSize: "17px", fontWeight: "500", margin: "8px 0" }}>
                    {title}
                </h2>
            </div>
        </div >
    );
};